import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const style = {
  //   position: "absolute" as "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

export const AboutModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={close}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="contain-sm"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Box sx={style} className=" p-5">
          <Typography>Forever free to play</Typography>

          <Typography>Upcoming features</Typography>

          <Typography variant="caption">
            <ul>
              <li>Invite online players to play</li>
              <li>Matchmaking based on hidden ELO rankings</li>
              <li>... suggestions welcome !</li>
            </ul>
          </Typography>
          <Typography>Beta version 0.1.0</Typography>
          <div className="d-flex">
            <Typography className=" pr-2">
              Send feature requests or bug reports
            </Typography>
            <a href="mailto:gaspard.feuvray@gmail.com?subject=Hive contact">
              {" "}
              here
            </a>
          </div>
          <div className="d-flex justify-content-center">
            <Button
              className="mt-4"
              onClick={close}
              variant="contained"
              size="large"
            >
              Close
            </Button>
          </div>
        </Box>
      </div>
    </Modal>
  );
};
